import React from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  SelectChangeEvent,
  Tooltip,
  Box,
  Typography,
  Chip
} from '@mui/material';
import { RpcConfig } from '../types/dex';

// 预设网络列表
const PRESET_NETWORKS = [
  {
    name: 'Binance Smart Chain',
    chainId: 56,
    url: 'https://bsc-mainnet.nodereal.io/v1/4b06d775febe481fbc614202d940a7cf',
    symbol: 'BNB'
  },
 
];

interface NetworkSelectorProps {
  /**
   * 当前选中的RPC配置
   */
  selectedRpc: RpcConfig | null;
  
  /**
   * 网络选择变更回调
   */
  onNetworkChange: (rpc: RpcConfig) => void;
}

/**
 * 网络选择器组件
 */
const NetworkSelector: React.FC<NetworkSelectorProps> = ({ selectedRpc, onNetworkChange }) => {
  /**
   * 处理网络选择变更
   */
  const handleNetworkChange = (event: SelectChangeEvent<number>) => {
    const chainId = event.target.value as number;
    const selectedNetwork = PRESET_NETWORKS.find(network => network.chainId === chainId);
    
    if (selectedNetwork) {
      onNetworkChange({
        chainId: selectedNetwork.chainId,
        url: selectedNetwork.url,
        name: selectedNetwork.name,
        symbol: selectedNetwork.symbol
      });
    }
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="network-select-label">网络</InputLabel>
      <Select
        labelId="network-select-label"
        id="network-select"
        value={selectedRpc?.chainId || ''}
        label="网络"
        sx={{
          padding: '3px',
        }}
        onChange={handleNetworkChange}
        renderValue={(chainId) => {
          const network = PRESET_NETWORKS.find(n => n.chainId === chainId);
          return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Chip 
                label={network?.name || '未知网络'} 
                size="small" 
                sx={{ mr: 1 }} 
              />
              <Typography variant="body2" color="text.secondary">
                Chain ID: {chainId}
              </Typography>
            </Box>
          );
        }}
      >
        {PRESET_NETWORKS.map((network) => (
          <MenuItem key={network.chainId} value={network.chainId}>
            <Tooltip title={`RPC URL: ${network.url}`} arrow placement="right">
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant="body1">{network.name}</Typography>
                <Typography variant="body2" color="text.secondary">
                  Chain ID: {network.chainId}
                </Typography>
              </Box>
            </Tooltip>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default NetworkSelector;
